import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import MissionVision from "@/components/MissionVision";
import VideoTestimonials from "@/components/VideoTestimonials";
import Services from "@/components/Services";
import WorkVideos from "@/components/WorkVideos";
import Gallery from "@/components/Gallery";
import Trust from "@/components/Trust";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.25, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="bg-[#FAFCFA] text-[#0F1A1C] antialiased">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <About />
        <MissionVision />
        <VideoTestimonials />
        <Services />
        <WorkVideos />
        <Gallery />
        <Trust />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}

export default App;
